import { Injectable } from '@angular/core';

export declare type LinkDefinition = {
  charset?: string;
  crossorigin?: string;
  href?: string;
  hreflang?: string;
  media?: string;
  rel?: string;
  rev?: string;
  sizes?: string;
  target?: string;
  type?: string;
} & {
  [prop: string]: string;
};

@Injectable({ providedIn: 'root' })
export class SeoLinksService {
  private canonicalUrl: string;
  private links: LinkDefinition[];
  setCanonicalURL(canonicalUrl: string) {
    this.canonicalUrl = canonicalUrl;
  }
  removeCanonical() {
    this.canonicalUrl = undefined;
  }
  setAlternateLinks(links: LinkDefinition[]) {
    this.links = links;
  }

  render(doc: Document) {
    if (this.canonicalUrl) {
      this.renderCanonicalLink(doc);
    }
    if (this.links && this.links.length > 0) {
      this.renderAlternatesLinks(doc);
    }
  }

  private renderCanonicalLink(doc: Document) {
    const link = doc.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', this.canonicalUrl);
    doc.head.appendChild(link);
  }

  private renderAlternatesLinks(doc: Document) {
    this.links.forEach(tag => {
      const link = doc.createElement('link');
      Object.keys(tag).forEach((prop: string) => link.setAttribute(prop, tag[prop].replace(/\/+$/, '')));
      doc.head.appendChild(link);
    });
  }
}
